/**
 * Correos desechables: los que se crean en un segundo y se tiran.
 *
 * Con uno de éstos, crear cuentas gratis sin fin cuesta nada, y cada cuenta
 * gratis trae su IA. El panel avisa al registrarse y el worker deja a estas
 * cuentas en el plan gratis sin IA (ver `usage.ts`). La lista son los
 * servicios más usados; no pretende ser completa: frena el abuso fácil.
 */
const DISPOSABLE_DOMAINS = new Set([
    '10minutemail.com', '10minutemail.net', '20minutemail.com', 'guerrillamail.com', 'guerrillamail.net',
    'guerrillamail.org', 'guerrillamailblock.com', 'sharklasers.com', 'grr.la', 'pokemail.net', 'spam4.me',
    'mailinator.com', 'mailinator.net', 'mailinator2.com', 'maildrop.cc', 'yopmail.com', 'yopmail.net',
    'yopmail.fr', 'tempmail.com', 'temp-mail.org', 'temp-mail.io', 'tempmail.net', 'tempmailo.com',
    'tempr.email', 'discard.email', 'dispostable.com', 'getnada.com', 'nada.email', 'throwawaymail.com',
    'trashmail.com', 'trashmail.de', 'trashmail.net', 'mohmal.com', 'emailondeck.com', 'fakeinbox.com',
    'mintemail.com', 'mytemp.email', 'burnermail.io', 'moakt.com', 'tmail.ws', 'tmpmail.org', 'tmpmail.net',
    'mail.tm', 'mailnesia.com', 'mailcatch.com', 'spamgourmet.com', 'inboxkitten.com', 'emailfake.com',
    'fakemail.net', 'luxusmail.org', 'harakirimail.com', 'mail-temp.com', 'minuteinbox.com', 'dropmail.me',
    '1secmail.com', '1secmail.net', '1secmail.org', 'byom.de', 'linshiyouxiang.net', 'cock.li',
]);
export function isDisposableEmail(email) {
    const domain = (email ?? '').trim().toLowerCase().split('@')[1];
    if (!domain)
        return false;
    /* También los subdominios («x.mailinator.com»). */
    const parts = domain.split('.');
    for (let index = 0; index < parts.length - 1; index++) {
        if (DISPOSABLE_DOMAINS.has(parts.slice(index).join('.')))
            return true;
    }
    return false;
}
//# sourceMappingURL=disposableEmail.js.map